import { render, staticRenderFns } from "./UsersShareViewsModal.vue?vue&type=template&id=5f56ecae&scoped=true"
import script from "./UsersShareViewsModal.vue?vue&type=script&lang=ts"
export * from "./UsersShareViewsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56ecae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f56ecae')) {
      api.createRecord('5f56ecae', component.options)
    } else {
      api.reload('5f56ecae', component.options)
    }
    module.hot.accept("./UsersShareViewsModal.vue?vue&type=template&id=5f56ecae&scoped=true", function () {
      api.rerender('5f56ecae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/UsersShareViewsModal.vue"
export default component.exports